import { createSlice } from '@reduxjs/toolkit';
import { getAllBanner, getDetailBanner } from './actions';

const initialState = {
  data: [],
  bannerDetail: {},
  isLoading: false,
  isError: false,
  errorMessage: '',
};

export const banner = createSlice({
  name: 'banner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllBanner.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(getAllBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getDetailBanner.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(getDetailBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getDetailBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bannerDetail = action.payload;
      });
  },
});

export default banner.reducer;
